<template>
  <div class="uk-grid" uk-grid>
    <div class="uk-width-1-1">
      <div class="uk-align-right">
        <a href="#" @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <div class="uk-width-1-1">
      <div class="uk-background-default uk-padding-small uk-panel uk-box-shadow-small panel-border" v-if="vehicle">
        <div class="uk-width-1-1">
          <div class="uk-text-lead uk-text-truncate">
            {{ name }}
          </div>
        </div>

        <div class="uk-grid" data-uk-grid>
          <div class="uk-width-1-1 uk-margin-remove">
            <div class="uk-text-muted uk-text-small">
              <span style="vertical-align: text-bottom;" uk-icon="icon: star; ratio: 0.8"></span>
              {{ vehicle.currentstatus }}
              <span
                class="uk-margin-small-left"
                style="vertical-align: text-bottom;"
                uk-icon="icon: hashtag; ratio: 0.8"
              ></span
              >Fahrzeug-Nr. {{ vehicle.carId }}
                <span
                  v-if="locationValue"
                  class="uk-margin-small-left"
                  style="vertical-align: text-bottom;"
                  uk-icon="icon: location; ratio: 0.8"
                ></span
                >{{ locationValue }}
              <span
                class="uk-text-success uk-margin-small-left"
                style="vertical-align: text-bottom;"
                uk-icon="icon: calendar; ratio: 0.8"
              ></span> &nbsp;
              <span
                v-if="tenant.knumber !== 'K10122' && tenant.knumber !== 'K10151'"
                class="uk-text-success"
              >{{ delivery }}</span>
              
            </div>
          </div>

          <div class="uk-width-3-5@l">
            <div uk-lightbox="animation: slide">
              <div class="uk-margin-bottom">
                <a
                  class="uk-inline"
                  :href="vehicle.images[0]['full']"
                  :caption="name"
                  v-if="showImages && vehicle.images && vehicle.images.length"
                >
                  <img :src="vehicle.images[0]['1024']" :alt="name" />
                </a>
                <img class="uk-width-1-1" v-else src="/img/placeholder.png" :alt="name" />
              </div>
              <div class="uk-grid uk-child-width-1-5 uk-grid-small" uk-grid v-if="showImages">
                <div v-for="(image, i) in vehicle.images" :key="i">
                  <a class="uk-inline" :href="image['full']" :caption="name">
                    <img :src="image['400']" alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="uk-width-2-5@l">
            <div class="uk-margin">
              <div class="uk-flex uk-flex-right">
                <button-bar :vehicle="vehicle"></button-bar>
              </div>
            </div>
            <div class="uk-width-1-1 uk-margin-small-bottom" v-if="vehicle.reserved">
              <div class="uk-flex uk-flex-right">
                <span class="uk-icon" style="color: #0891b2;">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                </svg>
                &nbsp;Fahrzeug reserviert!
                </span>
                
              </div>
            </div>
            <price-table :vehicle="vehicle"></price-table>
            <vehicle-specs-table :vehicle="vehicle"></vehicle-specs-table>
            <template v-if="(tenant.knumber === 'K10122' || tenant.knumber === 'K10151' || tenant.knumber === 'K10170') && vehicle.attachments.length">
              <a
                @click.prevent="downloadFile(vehicle.attachments[0])"
                href="#"
                target="_blank"
                class="uk-button uk-button-secondary uk-width-1-1 uk-flex uk-flex-middle uk-flex-center"
                style="text-transform: none; background-color: #0b5cd5"
              >
                <span class="uk-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" height="20">
                    <path
                      fill-rule="evenodd"
                      d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z"
                      clip-rule="evenodd"
                    />
                  </svg> 
                </span>
                {{ attachmentLabel }}
              </a>
              <!--
              <div class="uk-h4 uk-margin-small uk-heading-line uk-text-center">
                <span>Fahrzeugdokumente</span>
              </div>
              <div class="uk-flex uk-flex-wrap uk-margin">
                <div v-for="(attachment, index) in vehicle.attachments" :key="index">
                  <a
                    @click.prevent="downloadFile(attachment)"
                    href="#"
                    target="_blank"
                    class="uk-icon-button uk-margin-small-right uk-text-secondary"
                    uk-icon="file-pdf"
                  ></a>
                </div>
              </div>
              -->
            </template>
          </div>
        </div>

        <vehicle-description :vehicle="vehicle"></vehicle-description>
        <vehicle-damages v-if="tenant.knumber === 'K10149'" :vehicle="vehicle"></vehicle-damages>
        <div v-if="tenant.knumber === 'K10149'" class="uk-margin">
          <vehicle-note></vehicle-note>
        </div>

        <div class="uk-grid">
          <div class="uk-width-1-1">
            <div class="uk-align-right" uk-margin>
              <button-bar :vehicle="vehicle"></button-bar>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonBar from '@/components/vehicles/ButtonBar'
import PriceTable from '@/components/vehicles/PriceTable'
import VehicleService from '@/services/vehicle.service'
import VehicleSpecsTable from '@/components/vehicles/VehicleSpecsTable'
import VehicleDescription from '@/components/vehicles/VehicleDescription'
import axios from 'axios'
import Configuration from '@/configuration'
import { mapGetters } from 'vuex'
import moment from 'moment'
const VehicleNote = () => import('@/components/vehicles/VehicleNote')
const VehicleDamages = () => import('@/components/vehicles/VehicleDamages')

export default {
  data() {
    return {
      vehicle: null,
      hideLocation : ['K10170','K10139']
    }
  },
  components: {
    ButtonBar,
    PriceTable,
    VehicleSpecsTable,
    VehicleDescription,
    VehicleNote,
    VehicleDamages
  },
  mounted() {
    VehicleService.get(this.$route.params.id).then(response => {
      this.vehicle = response.data
    })
  },
  methods: {
    downloadFile(attachment) {
      axios({
        url: `${Configuration.value('apiFrontend')}/vehicle/attachment`,
        method: 'POST',
        data: { ...attachment },
        responseType: 'blob' // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', attachment['ref'])
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
        }, 1000)
      })
    }
  },
  computed: {
    ...mapGetters(['tenant','mode','merchantConfig']),
    name() {
      return `${this.vehicle.make} ${this.vehicle.model} ${this.vehicle.edition}`
    },
    locationValue() {
      if(this.hideLocation.includes(this.tenant.knumber)) {
        return null
      }
      if ((this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151') && this.vehicle.origin) {
        return this.vehicle.origin
      }

      if (this.vehicle.location) {
        return this.vehicle.location
      }

      return null
    },
    showImages() {
      if(this.mode !== 'merchant' && (this.merchantConfig && this.merchantConfig.general && this.merchantConfig.general.hideImages)) {
        return false
      }

      return true
    },
    delivery() {
      const date = moment()
      const formatedDate = date.format('YYYY-MM-DD')
      let output = ''
      if (this.vehicle.deliverydate && this.vehicle.deliverydate <= formatedDate) {
        output = 'Sofort lieferbar'
      } else if (this.vehicle.deliverydate > formatedDate) {
        const deliveryDate = moment(this.vehicle.deliverydate)
        let days = Math.ceil(date.diff(deliveryDate, 'days') / 7).toString()
        if (days.includes('-')) {
          days = days.replace('-', '')
        }
        output = parseInt(days) === 1 ? '1 Woche' : days + ' Wochen'
      } else if (!this.vehicle.deliverydate && this.vehicle.deliveryperiod !== 'KEINE' && this.vehicle.deliveryperiod !== '') {
        const days = Math.ceil(this.vehicle.deliveryperiod / 7)
        output = days === 1 ? '1 Woche' : days + ' Wochen'
      } else {
        output = 'Sofort lieferbar'
      }

      if(this.tenant.knumber === 'K10149') { // Brüning
        if(this.vehicle.deRegistrationDate) {
          output = 'Sofort lieferbar'
        } else {
          output = 'Im Vorlauf'
        }
      }

      return output
    },
    attachmentLabel() {
      if(this.tenant.knumber === 'K10122' || this.tenant.knumber === 'K10151') {
        return 'Zustandsbericht (vor Aufbereitung)'
      }
      return 'Fahrzeugbeschreibung'
    }
  }
}
</script>
